import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import Message from '../Message'

/**
 * Messages list component
 */
const MessagesList = ({ currentLang, onPreview, previewContent }) => {
  const messages = useSelector(state => state.conversations.messages) || []

  // Track whether we've seen the first user message (for showing conversation docs)
  let foundFirstUser = false

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {messages.map((message, index) => {
        let isFirstUserMessage = false
        if (!foundFirstUser && message.role === 'user') {
          isFirstUserMessage = true
          foundFirstUser = true
        }
        return (
          <Message
            key={message.id || index}
            message={message}
            currentLang={currentLang}
            isLast={index === messages.length - 1}
            isFirstUserMessage={isFirstUserMessage}
            onPreview={onPreview}
            previewContent={previewContent}
          />
        )
      })}
    </Box>
  )
}

export default MessagesList
